/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import 'bootstrap/dist/css/bootstrap.min.css';
import ConfigNavbar from './ConfigNavbar';
import Config from './Config';

function App() {
	return (
		<div>
			<ConfigNavbar/>
			<Config/>
		</div>
	);
}

export default App;
